import { render } from "./ssl-certificates.vue?vue&type=template&id=68952428&scoped=true"
import script from "./ssl-certificates.vue?vue&type=script&lang=js"
export * from "./ssl-certificates.vue?vue&type=script&lang=js"

import "./ssl-certificates.vue?vue&type=style&index=0&id=68952428&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68952428"]])

export default __exports__